import Icon from '@/components/atoms/Icon';

export default function ErrorState() {
  return (
    <div className="flex w-full items-center justify-center py-32">
      <div className="flex flex-col items-center">
        <Icon name="IconAlertTriangle" size={32} stroke={1.5} className="text-slate-400" />
        <div className="mt-2 max-w-[20rem] text-center text-sm leading-tight text-slate-400">
          Struggling to load your assets. A quick refresh might do the trick!
        </div>
      </div>
    </div>
  );
}
